import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import PedidoEfetuado from "../views/PedidoEfetuado";
import PaginaNaoEncontrada from "../views/PaginaNaoEncontrada";
import CriarPedido from "../views/CriarPedido.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/criar-pedido",
    name: "criarPedido",
    component: CriarPedido,
    beforeEnter(to, from, next) {
      if (
        sessionStorage.getItem("cidade") !== null &&
        sessionStorage.getItem("carro") !== null &&
        sessionStorage.getItem("bateria") !== null &&
        sessionStorage.getItem("cidade") !== "" &&
        sessionStorage.getItem("carro") !== "" &&
        sessionStorage.getItem("bateria") !== ""
      ) {
        next();
      } else {
        next({ path: "/" });
      }
    },
  },
  {
    path: "/pedido-efetuado-com-sucesso",
    name: "pedidoEfetuado",
    component: PedidoEfetuado,
    beforeEnter(to, from, next) {
      if (!to.params.email) {
        next({ path: "/" });
      } else {
        next();
      }
    },
  },
  {
    path: "/pagina-nao-encontrada",
    name: "paginaNaoEncontrada",
    component: PaginaNaoEncontrada,
  },
  {
    path: "*",
    redirect: "/pagina-nao-encontrada",
  },
];

const router = new VueRouter({
  mode: "history",
  base: "./",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
//component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
